(function () {
    'use strict';

    angular
        .module('surveyControllers')
        .controller('SurveyNotAvailableController', Controller);

    Controller.$inject = ['$scope', 'survey'];

    function Controller($scope, survey) {

        if (!_.isUndefined(survey) &&
            !_.isUndefined(survey.Campaign) &&
            !_.isUndefined(survey.Campaign.CampaignInvitation))
        {
            $scope.campaign = survey.Campaign;
            $scope.invitation = survey.Campaign.CampaignInvitation;
        }
    }
})();